import D2C_Key from '../Key'

class D2C_KeySSH extends D2C_Key {
  static objectType = 'keyType'
  static active = true
  static keyType = 'ssh'
}

export default D2C_KeySSH
